// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("default/spritesheet.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-back {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat -31px -5px;
}

.icon-blank {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat -57px -5px;
}

.icon-cancel {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat -68px -5px;
}

.icon-cut {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat -120px -5px;
}

.icon-add {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat -5px -5px;
}

.icon-remove {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat -161px -177px;
}

.icon-save {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat -198px -5px;
}

.icon-help {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat -109px -31px;
}

.icon-mini-add {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat -187px -31px;
}

.icon-mini-edit {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat -131px -99px;
}

.icon-mini-refresh {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat -149px -99px;
}

.icon-no {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat -165px -99px;
}

.icon-ok {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat -131px -125px;
}

.icon-edit {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat -83px -31px;
}

.icon-print {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat -83px -177px;
}

.icon-redo {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat -109px -177px;
}

.icon-reload {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat -135px -177px;
}

.icon-search {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat -204px -31px;
}

.icon-sum {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat -187px -135px;
}

.icon-tip {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat -187px -187px;
}

.icon-undo {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat -224px -5px;
}


/*.icon-filter{
	background:url('icons/filter.png') no-repeat center center;
}

.icon-large-picture{
	background:url('icons/large_picture.png') no-repeat center center;
}
.icon-large-clipart{
	background:url('icons/large_clipart.png') no-repeat center center;
}
.icon-large-shapes{
	background:url('icons/large_shapes.png') no-repeat center center;
}
.icon-large-smartart{
	background:url('icons/large_smartart.png') no-repeat center center;
}
.icon-large-chart{
	background:url('icons/large_chart.png') no-repeat center center;
}*/
`, "",{"version":3,"sources":["webpack://./wwwroot/Scripts/EasyUI/themes/icon.css"],"names":[],"mappings":"AAAA;IACI,wEAA+D;AACnE;;AAEA;IACI,wEAA+D;AACnE;;AAEA;IACI,wEAA+D;AACnE;;AAEA;IACI,yEAAgE;AACpE;;AAEA;IACI,uEAA8D;AAClE;;AAEA;IACI,2EAAkE;AACtE;;AAEA;IACI,yEAAgE;AACpE;;AAEA;IACI,0EAAiE;AACrE;;AAEA;IACI,0EAAiE;AACrE;;AAEA;IACI,0EAAiE;AACrE;;AAEA;IACI,0EAAiE;AACrE;;AAEA;IACI,0EAAiE;AACrE;;AAEA;IACI,2EAAkE;AACtE;;AAEA;IACI,yEAAgE;AACpE;;AAEA;IACI,0EAAiE;AACrE;;AAEA;IACI,2EAAkE;AACtE;;AAEA;IACI,2EAAkE;AACtE;;AAEA;IACI,0EAAiE;AACrE;;AAEA;IACI,2EAAkE;AACtE;;AAEA;IACI,2EAAkE;AACtE;;AAEA;IACI,yEAAgE;AACpE;;;AAGA;;;;;;;;;;;;;;;;;;EAkBE","sourcesContent":[".icon-back {\r\n    background: url('default/spritesheet.png') no-repeat -31px -5px;\r\n}\r\n\r\n.icon-blank {\r\n    background: url('default/spritesheet.png') no-repeat -57px -5px;\r\n}\r\n\r\n.icon-cancel {\r\n    background: url('default/spritesheet.png') no-repeat -68px -5px;\r\n}\r\n\r\n.icon-cut {\r\n    background: url('default/spritesheet.png') no-repeat -120px -5px;\r\n}\r\n\r\n.icon-add {\r\n    background: url('default/spritesheet.png') no-repeat -5px -5px;\r\n}\r\n\r\n.icon-remove {\r\n    background: url('default/spritesheet.png') no-repeat -161px -177px;\r\n}\r\n\r\n.icon-save {\r\n    background: url('default/spritesheet.png') no-repeat -198px -5px;\r\n}\r\n\r\n.icon-help {\r\n    background: url('default/spritesheet.png') no-repeat -109px -31px;\r\n}\r\n\r\n.icon-mini-add {\r\n    background: url('default/spritesheet.png') no-repeat -187px -31px;\r\n}\r\n\r\n.icon-mini-edit {\r\n    background: url('default/spritesheet.png') no-repeat -131px -99px;\r\n}\r\n\r\n.icon-mini-refresh {\r\n    background: url('default/spritesheet.png') no-repeat -149px -99px;\r\n}\r\n\r\n.icon-no {\r\n    background: url('default/spritesheet.png') no-repeat -165px -99px;\r\n}\r\n\r\n.icon-ok {\r\n    background: url('default/spritesheet.png') no-repeat -131px -125px;\r\n}\r\n\r\n.icon-edit {\r\n    background: url('default/spritesheet.png') no-repeat -83px -31px;\r\n}\r\n\r\n.icon-print {\r\n    background: url('default/spritesheet.png') no-repeat -83px -177px;\r\n}\r\n\r\n.icon-redo {\r\n    background: url('default/spritesheet.png') no-repeat -109px -177px;\r\n}\r\n\r\n.icon-reload {\r\n    background: url('default/spritesheet.png') no-repeat -135px -177px;\r\n}\r\n\r\n.icon-search {\r\n    background: url('default/spritesheet.png') no-repeat -204px -31px;\r\n}\r\n\r\n.icon-sum {\r\n    background: url('default/spritesheet.png') no-repeat -187px -135px;\r\n}\r\n\r\n.icon-tip {\r\n    background: url('default/spritesheet.png') no-repeat -187px -187px;\r\n}\r\n\r\n.icon-undo {\r\n    background: url('default/spritesheet.png') no-repeat -224px -5px;\r\n}\r\n\r\n\r\n/*.icon-filter{\r\n\tbackground:url('icons/filter.png') no-repeat center center;\r\n}\r\n\r\n.icon-large-picture{\r\n\tbackground:url('icons/large_picture.png') no-repeat center center;\r\n}\r\n.icon-large-clipart{\r\n\tbackground:url('icons/large_clipart.png') no-repeat center center;\r\n}\r\n.icon-large-shapes{\r\n\tbackground:url('icons/large_shapes.png') no-repeat center center;\r\n}\r\n.icon-large-smartart{\r\n\tbackground:url('icons/large_smartart.png') no-repeat center center;\r\n}\r\n.icon-large-chart{\r\n\tbackground:url('icons/large_chart.png') no-repeat center center;\r\n}*/\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
